import Hello from './../../components/Hello.vue'
import Home from './../../components/views/Home.vue'

export default [
  { path: '/', component: Home, name: 'root' },
]



// WEBPACK FOOTER //
// ./src/vue/router/routes.js